// Copyright (c) 2016 Deere & Company

import KeyValuePair, { getDefaultState as getDefaultKeyValueState } from '../../../../sharedmodules/state/key-value-pair';
import t from 'tcomb';

const UseAmount = t.struct({
    amount: t.String,
    unit: KeyValuePair,
}, {
    name: 'UseAmount',
    strict: true,
});

export const getDefaultState = () => new UseAmount({
    amount: '',
    unit: getDefaultKeyValueState(),
});

export default UseAmount;
